
import {
  defineComponent,
  ref,
  reactive,
  toRefs,
  onMounted,
  computed,
  watch,
  nextTick
} from 'vue'
import dataLoad from './dataLoad.vue'
import Table from '@/components/table.vue'
import { useRoute } from 'vue-router'
import f10Api from '@/api/f10Api'

export default defineComponent({
  components: { dataLoad, Table },
  props: {
    token: {
      type: String,
      default: function () {
        return ''
      }
    }
  },
  setup(props, context) {
    const pageData: any = reactive({
      spinning: true,
      columns: [
        {
          title: '代码',
          dataIndex: 'Inst',
          key: 'Inst',
          width: '100px',
          align: 'left'
        },
        {
          title: '名称',
          dataIndex: 'Abbr',
          key: 'Abbr',
          width: '110px',
          align: 'left'
        },
        {
          title: '权重',
          dataIndex: 'Weight',
          key: 'Weight',
          width: '130px'
        },
        {
          title: '行业',
          dataIndex: 'Industry',
          key: 'Industry',
          width: '140px',
          align: 'left'
        }
      ],
      data: []
    })
    const route = useRoute()
    watch(
      () => (props as any).token,
      (val) => {
        if (val) {
          getBaseIndexF10Top10Stock()
        }
      },
      { deep: true, immediate: true }
    )

    function getBaseIndexF10Top10Stock() {
      const data: any = {}
      // 0：日期（默认），1：股票ID，2：评价，3：变动（1为首次,2为调高,3为调低,4为维持），4：目标价，5：机构，6：作者
      // 0:desc（默认）,1:asc
      data.data = {
        Exch: route.query.market,
        Inst: route.query.code
      }
      data.headers = {
        token: (props as any).token
      }
      f10Api
        .baseIndexF10Top10Stock(data)
        .then((res: any) => {
          if (res.Code === 0) {
            pageData.data = res.Data.List.map((v) => {
              return {
                ...v,
                Weight: v.Weight.toFixed(2)
              }
            })
            context.emit('chageTime', {
              index: 3,
              time: res.Data.EndDate
            })
          }
          pageData.spinning = false
        })
    }

    return {
      ...toRefs(pageData)
    }
  }
})
